export default __webpack_public_path__ + "static/media/BARRA_white.82f161f8.svg";